import { render, staticRenderFns } from "./AccountHolderCredentials.vue?vue&type=template&id=42f2c988&scoped=true"
import script from "./AccountHolderCredentials.vue?vue&type=script&lang=ts"
export * from "./AccountHolderCredentials.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderCredentials.vue?vue&type=style&index=0&id=42f2c988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2c988",
  null
  
)

export default component.exports